import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children?: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  public props!: Props;
  public state: State = {
    hasError: false
  };

  public static getDerivedStateFromError(_: Error): State {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Uncaught error inside boundary:", error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return this.props.fallback || (
        <div className="bg-red-950/20 border border-red-500/30 p-6 rounded-xl text-left text-xs space-y-3 font-sans">
          <span className="text-red-400 font-extrabold uppercase font-mono tracking-wider block text-[10px]">⚠️ SECURE NODE ERROR SHIELD ACTIVE</span>
          <div className="space-y-1 text-slate-300 font-mono text-[10px]">
            <p className="font-bold">Grant Funding Pack needs attention.</p>
            <p className="text-slate-500">Please check admin logs or try again.</p>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
